// extracted by mini-css-extract-plugin
export default {"buttons":"ApproveOrder_buttons__1uJbn","buttonsWrapper":"ApproveOrder_buttonsWrapper__KFGxw"};